import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OutputService {
  @Output() output: EventEmitter<any> = new EventEmitter();
  @Output() output1: EventEmitter<any> = new EventEmitter();
  @Output() output2: EventEmitter<any> = new EventEmitter();
  @Output() document: EventEmitter<any> = new EventEmitter();
  @Output() company: EventEmitter<any> = new EventEmitter();
  @Output() traning: EventEmitter<any> = new EventEmitter();
  @Output() technician: EventEmitter<any> = new EventEmitter();
  @Output() cart: EventEmitter<any> = new EventEmitter();
  @Output() pdfview: EventEmitter<any> = new EventEmitter();
  @Output() logbook: EventEmitter<any> = new EventEmitter();
  @Output() logbookemail: EventEmitter<any> = new EventEmitter();
  constructor() { }

  getPagesListener() {
    return this;
  }

  RefreshWithOutParams(): void {
    this.output.emit();
  }

  RefreshData(Data): void {
    this.output.emit(Data);
  }

  RefreshWithOutParams1(): void {
    this.output1.emit();
  }

  RefreshWithOutParams2(): void {
    this.output2.emit();
  }

  RefreshData2(Data): void {
    this.output2.emit(Data);
  }

  RefreshWithOutParamsDocument(): void {
    this.document.emit();
  }

  RefreshWithOutParamsCompany(): void {
    this.company.emit();
  }

  RefreshWithOutParamsTraning(): void {
    this.traning.emit();
  }

  RefreshWithOutParamsTechnician(): void {
    this.technician.emit();
  }

  AddCartData(Data): void {
    this.output.emit(Data);
  }

  RefreshPreviewData(Data): void {
    this.pdfview.emit(Data);
  }

  RefreshWithOutParamsLogBook(): void {
    this.logbook.emit();
  }

  RefreshLogBookEmail(Data): void {
    this.logbookemail.emit(Data);
  }

}

